import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { GlobalConstants, WebAPIConstants } from 'src/app/services/globalConstants/global-constants.service';

@Component({
  selector: 'app-terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.scss'],
})
export class TerminoCondicionComponent implements OnInit {

  constructor(
    private _modalCtrl: ModalController
  ) { }

  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  public btnCloseClick() {

    this._modalCtrl.dismiss();
  }

  public btnTelClick() {
    window.open("tel:+528444161901")
  }

  public btnEmailClick() {
    window.open('mailto:contacto@pastelerialasalle.com.mx', '_new');
  }

}
